/**
 *  Current namespace values that exist only in two spaces:
 *    - 'render'
 *       - Todo: sub unique id for a type of render
 *    - 'payment'
 *       - Todo: sub unique id for a type of payment
 */

export interface Announcement {
  level: "error" | "warn" | "info" | "command" | "debug";
  namespace: PubSubNamespace; // enum
  message: PubSubMessage;
  payload?: Record<string, string>;
}

export enum PubSubNamespace {
  render = "render",
  payment = "payment",
  external = "external",
  unknown = "unknown",
  field = "field",
  form = "form",
  debug = "debug",
}

export enum PubSubMessage {
  Unknown = "Unknown",
  PubSubPing = "pubSubPing",
  SecurityRequirementsNotMet = "SecurityRequirementsNotMet",
  RequiredAPIsNotAvailable = "RequiredAPIsNotAvailable",
  CreditCardEncryptionError = "CreditCardEncryptionError",
  GiftCardEncryptionError = "GiftCardEncryptionError",
  SepaEncryptionError = "SepaEncryptionError",
  EcpAccountNumberEncryptionError = "EcpAccountNumberEncryptionError",
  EcpRoutingNumberEncryptionError = "EcpRoutingNumberEncryptionError",
  MountSuccess = "MountSuccess",
  InitialLoadComplete = "InitialLoadComplete",
  UnknownError = "UnknownError",
  PaymentSuccess = "PaymentSuccess",
  PaymentUnsuccessful = "PaymentUnsuccessful",
  PaymentPending = "PaymentPending",
  PaymentError = "PaymentError",
  PaymentValidationInProgress = "PaymentValidationInProgress",
  PaymentHandlingInProgress = "PaymentHandlingInProgress",
  PaymentValidationFailed = "PaymentValidationFailed",
  UpdateIntentFailed = "UpdateIntentFailed",
  ExternalSubmitTriggered = "ExternalSubmitTriggered",
  PayByBankCompletionError = "PayByBankCompletionError",
  FieldValidationError = "FieldValidationError",
  FieldValidationSuccess = "FieldValidationSuccess",
  FormValidity = "FormValidity",
  FormReady = "FormReady",
  Ready = "FormLoadedAtLeastOnePaymentMethod",
  FailedToLoad = "NoPaymentMethodWasLoadedInTheForm",
  ApplySurcharge = "ApplySurcharge",
  RemoveSurcharge = "RemoveSurcharge",
  PazeLoadSuccess = "PazeLoadSuccess",
  PazeLoadFailed = "PazeLoadFailed",
  GooglePayCanceled = "GooglePayCanceled",
  GooglePayError = "GooglePayError",
  GooglePayOpened = "GooglePayOpened",
  GooglePayReady = "GooglePayReady",
  MethodOfPaymentOptionNotSupported = "MethodOfPaymentOptionNotSupported",
  ApplePayOpened = "ApplePayOpened",
  ApplePayCanceled = "ApplePayCanceled",
}

export type AnnouncementCallback = (value: Announcement) => void;

export type Subscribers = AnnouncementCallback[];

export type Subscribe = (
  callback?: AnnouncementCallback
) => () => boolean | undefined;

export type Publish = (message: Announcement) => void;

export interface PubSub {
  subscribe: Subscribe;
  publish: Publish;
  getSubscribers: () => Subscribers;
  clearAllSubscribers: () => void;
}
